import React, { useState } from 'react'
import { Switch, TableCell, Typography } from '@mui/material';
import { getTranslateByKey, haveIgnoreElement } from '@/main/services/utils';
import { HolidaysResponse } from '@/main/models/response/holidaysResponse';
import ModalHoliday from '../../modalHoliday/modalHoliday';
import { HolidaySaveRequest } from '@/main/models/request';
import { holidaysApi } from '@/main/api';
import { toast } from 'react-toastify';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Button from '@/main/components/shared/button/button';
import * as S from './styles';

interface IRowDataHolidaysProps {
  holidays: HolidaysResponse;
  updateRowDataGrid: (row: HolidaysResponse) => void;
}

function RowDataHolidays({
  holidays,
  updateRowDataGrid
}: IRowDataHolidaysProps) {
  const [isChecked, setIsChecked] = useState(holidays.active);
  const [isOpenModalHoliday, setIsOpenModalHoliday] = useState<boolean>(false);
  const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
  const handleOpen = () => setIsOpenModalConfirm(true);


  function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
    if (haveIgnoreElement(e.target as HTMLElement)) return;
    setIsOpenModalHoliday(true);
  }

  function handleToggleStatus(event: React.ChangeEvent<HTMLInputElement>, checked: boolean){
    setIsChecked(checked);
    if (!checked === true) {
      handleOpen();
    } else {
      changeStatus(checked);
    }
  }

  function updateRowDataGridWithActive(row: HolidaysResponse){
   updateRowDataGrid(row);
   setIsChecked(row.active);
  }

  function changeStatus(checked: boolean) {
    const guidHoliday = holidays.guidHoliday
    const request = {
      guidHoliday: String(guidHoliday),
      checked: checked
    } as HolidaySaveRequest;
    holidaysApi.changeStatusHoliday(request).then(() => {
      toast.success(
        getTranslateByKey('information.savedSuccess')
      );
      updateRowDataGrid({
        ...holidays,
        active: checked,
      });
    }).catch(error => {setIsChecked(prev => !prev)});
  }

  return (
    <>
       <S.Container $isSizeLong onClick={handleClickRow}>
      <TableCell><S.CustomColumn title={holidays.date}>{holidays.date}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={holidays.description}>{holidays.description}</S.CustomColumn></TableCell>
      <TableCell><S.CustomColumn title={holidays.recurringFormatted}>{holidays.recurringFormatted}</S.CustomColumn></TableCell>
      <TableCell>
        <Switch
         className='ignore-click'
         name='status-holiday'
         color="primary"
         checked={isChecked}
         onChange={(event, checked) => handleToggleStatus(event, checked)}
         />
      </TableCell>
    </S.Container>
    <ModalHoliday
        itemHoliday={holidays}
        isOpenModal={isOpenModalHoliday}
        updateRowDataGrid={updateRowDataGridWithActive}
        closeModal={() => setIsOpenModalHoliday(false)}
        setIsOpenModal={setIsOpenModalHoliday}
      />
      <KogModalFadeComponent open={isOpenModalConfirm} setOpen={setIsOpenModalConfirm}>
       <S.BoxModal>
          <Typography
            id="id-modal-holiday-title"
            variant="h6"
            component="h2">
            {getTranslateByKey('information.warning')}
          </Typography>
          <Typography id="id-modal-holiday-description">
            {getTranslateByKey('information.holidaywarning')}
          </Typography>
          <Typography id="id-modal-holiday-descriptions">
            {getTranslateByKey('information.messageConfirmAction')}
          </Typography>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem'
            }}>
            <SecondaryButton
              type="button"
              style={{ marginTop: 10 }}
              onClick={() => {
                 setIsChecked(prev => !prev)
                 setIsOpenModalConfirm(false);
              }}>
              {getTranslateByKey('information.no')}
            </SecondaryButton>
            <Button
              type="button"
              style={{ marginTop: 10 }}
              onClick={() => {
                changeStatus(isChecked);
                 setIsOpenModalConfirm(false);
              }}>
              {getTranslateByKey('information.yes')}
            </Button>
          </div>
        </S.BoxModal>
      </KogModalFadeComponent>
    </>
  );
}

export default RowDataHolidays